<template>
  <div class="w-100">
    <div v-for="(reserve, index) in reservationDetails" :key="index">
      <BCard
        v-for="item in reserve.priceCategories"
        :key="item.priceCategoryId"
        class="my-1"
      >
        <template #header>
          <div
            class="w-100 d-flex align-items-center justify-content-between border-bottom-success"
          >
            <span>
              {{ item.priceCategoryTitle }}
            </span>
            <span>{{ customFullDateConvert(reservationDate) }}</span>
          </div>
        </template>
        <BCardBody>
          <div class="d-flex flex-column">
            <div
              v-for="student in item.students"
              :key="student.studentId"
              class="my-2"
            >
              <b-link :to="`/master/users/${student.studentId}`">
                -
                {{ student.studentUserFullName }}
                <span style="font-size: 12px"
                  >({{ student.resevedTime }} دقیقه)</span
                >
              </b-link>
              <div
                v-if="student.description"
                style="font-size: 12px; margin-top: 4px"
              >
                <span> توضیحات زبان آموز: </span>
                {{ student.description }}
              </div>
            </div>
          </div>
        </BCardBody>
      </BCard>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reservationDetails: {
      type: Array,
      required: true,
    },
    reservationDate: {
      type: [String, Date],
      required: true,
    },
  },
  mixins: [timeConvertUtils],
  components: {
    BCardGroup,
    BCard,
    BCardText,
    BCardBody,
    BButton,
    BLink,
  },
};

import {
  BCardGroup,
  BCard,
  BCardText,
  BCardBody,
  BButton,
  BLink,
} from "bootstrap-vue";

import timeConvertUtils from "@/mixins/timeConvertUtils";
</script>
